export var notificationsStatusEnum;
(function (notificationsStatusEnum) {
    notificationsStatusEnum[notificationsStatusEnum["battle_won"] = 1] = "battle_won";
    notificationsStatusEnum[notificationsStatusEnum["ticket_claim"] = 2] = "ticket_claim";
})(notificationsStatusEnum || (notificationsStatusEnum = {}));
//# sourceMappingURL=notifications.constants.js.map